import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { FileDto } from '@usucampeao/lib-reurb-simplificado';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RegistrationState, RegistrationStore } from './registration.store';

@Injectable({ providedIn: 'root' })
export class RegistrationQuery extends QueryEntity<RegistrationState> {
  public areLoaded$ = this.select(state => {
    return state.loaded;
  });

  constructor(protected store: RegistrationStore) {
    super(store);
  }

  /**
   * Busca arquivos de um imóvel
   * @param id id do imóvel
   * @returns arquivos do imóvel
   */
  public getFiles(id: string): Observable<FileDto[]> {
    return this.selectEntity(id)
      .pipe(
        map(property => property?.files)
      );
  }
}
